var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import { suomifiTheme, defaultTokens, } from '../';
var internalTokens = function (tokens) {
    return !!tokens ? __assign({}, defaultTokens, tokens) : defaultTokens;
};
export var withSuomifiDefaultProps = function (_a) {
    var tokens = _a.tokens, as = _a.as, props = __rest(_a, ["tokens", "as"]);
    return (__assign({}, props, { tokens: internalTokens(tokens) }, (!!as ? { asProp: as } : {})));
};
export var themeOrTokens = function (props) {
    return 'theme' in props ? props.theme : suomifiTheme(props.tokens);
};
//# sourceMappingURL=defaults.js.map